<template>
    <button class="cause-toggle" type="button" @click="viewToggle">
        <SvgIcon
            v-if="view === 'block'"
            width="52px"
            height="28px"
            icon="toggle-block"
        />
        <SvgIcon v-else width="52px" height="28px" icon="toggle-list" />
    </button>
</template>

<script>
import SvgIcon from "../UI/SvgIcon";
export default {
    name: "Toggle",
    components: { SvgIcon },
    props: ["view"],

    methods: {
        viewToggle: function() {
            this.$emit("viewToggle");
        }
    }
};
</script>
